import { toast } from "react-toastify";
import APIPaths from "../../utils/APIPaths";
import axiosInstance from "../axiosInstance";
import moment from "moment";

export const createClientService = async (bodyObj) => {
  let response;
  try {
    response = await axiosInstance.post(APIPaths.CREATE_CLIENT, bodyObj);
    if (response.status === 201) {
      return response.data;
    } else if (response.data.includes("Error:")) {
      toast.error(response.data);
      return {
        status: 400,
        data: response,
      };
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response?.status === 409) {
      return error.response;
    }
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const createPrescriptionService = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.CREATE_PRESCRIPTION,
      bodyObj,
    );

    if (response.status === 201) {
      toast.success(response.message);
      return response.data;
    }
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong.");
    }
    return null;
  }
};

export const updateClientService = async (bodyObj) => {
  return axiosInstance
    .put(APIPaths.UPDATE_CLIENT, bodyObj)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else if (response.data.includes("Error:")) {
        toast.error(response.data);
        return {
          status: 400,
          data: response,
        };
      } else {
        toast.error(response);
        return response;
      }
    })
    .catch((error) => {
      if (error.response?.status === 409) {
        return error.response;
      }
      if (error.response.data.errors) {
        for (const item in error.response.data.errors) {
          toast.error(error.response.data.errors[item]);
        }
      } else {
        toast.error(error.response.data);
      }
    });
};

export const getAvailableTimingsService = async (id, date, addressId) => {
  try {
    const URL = `${APIPaths.GET_AVAILABLE_TIMING}/${id}/${date}/${addressId}`;
    const response = await axiosInstance.get(URL);

    if (response.status === 200) {
      return response.data;
    } else {
      toast.error(response.response?.data);
      return null;
    }
  } catch (error) {}
};

export const createAppointmentService = async (bodyObj) => {
  const response = await axiosInstance
    .post(APIPaths.CREATE_APPOINTMENTS, bodyObj)
    .then((response) => {
      if (response.status === 201) {
        toast.success("Appointment created successfully");
        return response;
      }
    })
    .catch((error) => {
      toast.error(error.response.data);

      return error.response;
    });
  return response;
};

export const AddDiseaseService = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_DISEASE, bodyObj);

    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data);
    return null;
  }
};

export const getAppointmentList = async (page, rowsPerPage, data) => {
  try {
    const URL = `${APIPaths.GET_ALL_APPOINTMENTS}/${page}/${rowsPerPage}`;
    const response = await axiosInstance.get(URL, {
      params: {
        appointmentFilterDto: data,
      },
    });

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (error) {}
};

function formatDate(date) {
  return moment.utc(date).format("YYYY-MM-DDTHH:mm:ss[Z]");
}

export const getTodaysAppointmentList = async (
  consultantId,
  text,
  page,
  rowsPerPage,
  selectedBranchId,
) => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const formattedToday = formatDate(today);
  const formattedTomorrow = formatDate(tomorrow);

  try {
    const URL = `${APIPaths.GET_TODAYS_APPOINTMENTS}list/${formattedToday}/${formattedTomorrow}/${page}/${rowsPerPage}`;
    const response = await axiosInstance.get(URL, {
      params: {
        consultantId: consultantId,
        text: text,
        addressId: selectedBranchId,
      },
    });

    if (response.status === 200) {
      return response;
    } else if (response.status === 204) {
      return [];
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
    return {};
  }
};

export const getWidgetAppointmentData = async (selectedBranchId) => {
  try {
    const response = await axiosInstance.get(APIPaths.GET_APPOINTMENTS_COUNT, {
      params: {
        addressId: selectedBranchId,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
    return {};
  }
};

export const getWidgetEarningData = async (earningPeriod, selectedBranchId) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_EARNING}/${earningPeriod}`,
      {
        params: {
          addressId: selectedBranchId,
        },
      },
    );
    return response.data;
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
    return {};
  }
};

export const getClientByValue = async (value, page, rowsPerPage) => {
  try {
    const URL = `${APIPaths.GET_CLIENT_LIST_BY_VALUE}/${page}/${rowsPerPage}/${value}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200 || response.status === 204) {
      return response;
    }
    return [];
  } catch (error) {}
};

export const uploadClientsCsvService = async (data) => {
  const response = await axiosInstance
    .post(APIPaths.ADD_CLIENTS_LIST, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.code === "ERR_NETWORK" || error.response.status === 500) {
        toast.error("Something went wrong");
        return { status: 500 };
      }
      return error.response;
    });
  return response;
};

export const downloadSampleCsv = async () => {
  try {
    const URL = APIPaths.DOWNLOAD_SAMPLE_CSV;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/csv",
      },
    });
    if (response.status === 200) {
      toast.success("Sample CSV downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Sample CSV not available");
    }
  } catch (error) {
    toast.error("Sample CSV download failed");
  }
};

export const getAppointmentsById = async (id) => {
  try {
    const URL = APIPaths.GET_APPOINTMENT_BY_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {}
};

export const getAppointmentsByConsultantUserName = async (
  userName,
  page,
  rowsPerPage,
  addressId,
) => {
  try {
    const URL = `${APIPaths.GET_APPOINTMENTS_BY_CONSULTANT_USER_NAME}/${userName}/${page}/${rowsPerPage}`;
    const response = await axiosInstance.get(URL, {
      params: {
        addressId: addressId,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {}
};

/**
 * method fetches and returns client information by client ID
 * @param {*} clientId
 * @returns
 */
export const getClientById = async (clientId) => {
  try {
    const response = await axiosInstance.get(
      APIPaths.GET_CLIENT_BY_ID + clientId,
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {
    toast.error(error.data.message);
  }
};

export const getAppointmentByClientUserName = async (
  id,
  page,
  rowsPerPage,
  addressId,
) => {
  try {
    const URL = APIPaths.GET_CLIENT_DETAILS + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      let userName = response.data.userName;
      const URL1 = `${APIPaths.GET_APPOINTMENTS_BY_CLIENT_USER_NAME}${userName}/${page}/${rowsPerPage}`;
      const response1 = await axiosInstance.get(URL1, {
        params: {
          addressId: addressId,
        },
      });

      return response1.data;
    } else {
      return [];
    }
  } catch (error) {}
};

export const getPrescriptionByAppointmentId = async (id) => {
  try {
    const URL = APIPaths.GET_PRESCRIPTION_BY_APPOINTMENT_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {}
};

export const getClientByClientId = async (id) => {
  const URL = APIPaths.GET_CLIENT_DETAILS + id;
  const response = await axiosInstance
    .get(URL)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      toast.error(error.response.data); //will get replaced by navigate to page not found.
      return {};
    });
  return response.data;
};

export const getDiseaseByClientId = async (id) => {
  try {
    const URL = APIPaths.GET_DISEASE_BY_CLIENT_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {}
};

export const putUpdateAppointment = async (bodyObj) => {
  try {
    const URL = APIPaths.UPDATE_APPOINTMENT;
    const response = await axiosInstance.put(URL, bodyObj).catch((error) => {
      if (!error.response || !error.response?.data) {
        toast.error("Network error. Please try again.");
        return { status: 0 };
      }

      if (error.response?.status === 400) {
        if (error.response?.data?.errors) {
          for (const item in error.response?.data?.errors) {
            toast.error(error.response?.data?.errors[item]);
          }
        } else {
          toast.error(error.response?.data?.message || error.response?.data);
        }
        return { status: 400 };
      } else {
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.errors?.[0] ||
            "Something went wrong.ddd",
        );
        return { status: error.response?.status };
      }
    });

    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Unexpected error occurred.");

    return error?.response;
  }
};

export const deleteDiseaseAPIHandler = async (id) => {
  try {
    const URL = APIPaths.DELETE_DISEASE_BY_ID + id;
    const response = await axiosInstance.delete(URL);

    if (response.status === 200) {
      toast.success("Disease deleted successfully.");
      return response.data;
    } else {
      toast.error("Something went wrong.");
      return null;
    }
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error("Something went wrong");
    }
  }
};

export const uploadDocumentService = async (data) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.UPLOAD_CLIENT_DOCUMENT,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error) {
      if (error.code === "ERR_NETWORK" || error.response.status === 500) {
        toast.error("File upload failed");
        return { status: 500 };
      } else if (error.response) {
        toast.error(error.response.data);
      }

      return error.response;
    }
  }
};

export const getClientDocumentListByClientId = async (id) => {
  try {
    const URL = APIPaths.GET_CLIENT_ALL_DOCUMENT_LIST_BY_CLIENT_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {
    toast.error("Error while getting document");
  }
};

export const getClientCasePaperByAppointmentId = async (
  id,
  documentCategory,
) => {
  try {
    const URL = `${APIPaths.GET_CLIENT_CASE_PAPER_BY_APPOINTMENT_ID}/${id}/${documentCategory}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    toast.error("Error while getting document");
  }
};

export const deleteDocumentById = async (id) => {
  try {
    const URL = APIPaths.DELETE_CLIENT_DOCUMENT_BY_ID + id;
    const response = await axiosInstance.delete(URL);

    if (response.status === 200) {
      if (response?.data && response?.data != null) {
        toast.success(response.data.message);
        return response.data;
      }
      return null;
    } else {
      toast.error("While Deleting File, Something Went Wrong");
      return null;
    }
  } catch (error) {
    if (error.response.data) {
      return toast.error(error.response.data);
    } else if (error.response.status === 500) {
      return toast.error("You can not delete shared file.");
    } else {
      toast.error("Delete file failed.");
    }
  }
};

export const downloadPrescriptionPDFByPrescriptionID = async (id, data) => {
  try {
    const URL = APIPaths.DOWNLOAD_PRESCRIPTION_PDF_BY_PRESCRIPTION_ID + id;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutDto: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    });

    if (response.status === 200) {
      toast.success("Prescription PDF downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Prescription not available");
    }
  } catch (error) {
    toast.error("Prescription PDF download failed");
  }
};

export async function downloadDocumentByDocumentID(id) {
  try {
    const URL = APIPaths.GET_CLIENT_DOCUMENT_BY_ID + id;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    }
  } catch (error) {
    if (error.code === "ERR_NETWORK" || error.response.status === 500) {
      return toast.error("File download failed");
    } else if (error.response.status === 403) {
      return toast.error("File download is not allowed.");
    } else if (error.response.status === 404) {
      return toast.error("File not found");
    } else {
      toast.error("File download failed");
    }
  }
}

export async function viewDocumentByDocumentID(id) {
  try {
    const URL = APIPaths.GET_CLIENT_DOCUMENT_BY_ID + id;
    const response = await axiosInstance.get(URL, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View file failed");
  }
}

export const viewPrescriptionPDFByPrescriptionID = async (id, data) => {
  try {
    const URL = APIPaths.DOWNLOAD_PRESCRIPTION_PDF_BY_PRESCRIPTION_ID + id;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutDto: data,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View document failed");
  }
};

export const getInstructionList = async () => {
  try {
    const URL = APIPaths.GET_INSTRUCTION_LIST;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (error) {}
};

export const getDosageList = async () => {
  try {
    const URL = APIPaths.GET_DOSAGE_LIST;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (error) {}
};

export const getMedicineList = async (KEY, categoryNames) => {
  const response = await axiosInstance
    .get(APIPaths.GET_MEDICINE_LIST, {
      params: {
        keyword: KEY,
        category: categoryNames.join(","),
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return [];
    });
  return response;
};

export const getExerciseList = async () => {
  const response = await axiosInstance
    .get(APIPaths.GET_EXERCISE_LIST)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      toast.error(error.response.data);
      return [];
    });
  return response;
};

/**
 * Method return frequently used exercises list for particular consultant by consultant Id
 * @param {*} consultantId
 * @returns
 */
export const getFrequentlyUsedExerciseList = async (consultantId) => {
  const response = await axiosInstance
    .get(APIPaths.GET_FREQUENTLY_USED_EXERCISES, {
      params: {
        consultantId: consultantId,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response.status === 400) {
        return [];
      } else {
        toast.error(error.response.data);
        return [];
      }
    });
  return response;
};

/**
 * Post method adds custom exercise
 * @param {*} bodyObj
 * @returns
 */
export const addCustomExercise = async (bodyObj) => {
  const response = await axiosInstance
    .post(APIPaths.ADD_EXERCISE, bodyObj, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.code === "ERR_NETWORK" || error.response.status === 500) {
        toast.error("Something went wrong");
        return { status: 500 };
      } else {
        toast.error(error.response.data);
        return null;
      }
    });
  return response;
};

/**
 * Method update exercise by exercise Id
 * @param {*} bodyObj
 * @param {*} exerciseId
 * @returns
 */
export const updateCustomExercise = async (bodyObj, exerciseId) => {
  const response = await axiosInstance
    .put(`${APIPaths.UPDATE_EXERCISE}/${exerciseId}`, bodyObj, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.code === "ERR_NETWORK" || error.response.status === 500) {
        toast.error("Something went wrong");
        return { status: 500 };
      } else {
        toast.error(error.response.data);
        return null;
      }
    });
  return response;
};

/**
 * Method Delete exercise by exerciseId
 * @param {*} ExerciseId
 * @returns
 */
export const deleteExercise = async (ExerciseId) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_EXERCISE}/${ExerciseId}`,
    );
    if (response.status === 200) {
      toast.success("Exercise deleted successfully");
      return response.data;
    }
  } catch (error) {
    if (error.response.data) {
      return toast.error(error.response.data);
    } else if (error.response.status === 500) {
      return toast.error(
        "You cannot delete exercise as it is used in exercise template .",
      );
    } else {
      toast.error("Delete exercise failed.");
    }
  }
};

export const getExerciseImage = async (ID) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_EXERCISE_IMAGE}/${ID}`, {
      responseType: "arraybuffer",
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      toast.error(error.response.data);
      return [];
    });
  return response;
};

export const addNewMedicine = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_MEDICINE, reqObj);
    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const addNewDisease = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_NEW_DISEASE, reqObj);
    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getDiseaseList = async (KEY) => {
  const response = await axiosInstance
    .get(APIPaths.GET_DISEASE_LIST, {
      params: {
        keyword: KEY,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      toast.error(error.response.data);
      return [];
    });
  return response;
};

export const downloadExercisePrescriptionPDF = async (
  finalExerciseListToPrint,
  data,
) => {
  try {
    const URL = APIPaths.DOWNLOAD_EXERCISE_PRESCRIPTION;
    const response = await axiosInstance.post(URL, finalExerciseListToPrint, {
      params: {
        layoutDto: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    });

    if (response.status === 200) {
      toast.success("Prescription PDF Downloaded Successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Prescription Not Available");
    }
  } catch (error) {
    toast.error("Prescription PDF Download failed");
  }
};

export const viewExercisePrescriptionPDF = async (
  finalExerciseListToPrint,
  data,
) => {
  try {
    const URL = APIPaths.DOWNLOAD_EXERCISE_PRESCRIPTION;
    const response = await axiosInstance.post(URL, finalExerciseListToPrint, {
      params: {
        layoutDto: data,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View document failed");
  }
};

export const getTemplateList = async () => {
  try {
    const response = await axiosInstance.get(APIPaths.GET_ALL_TEMPLATES);

    if (response.status === 200) {
      return response;
    } else {
      toast.error(response);
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const addTemplate = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_TEMPLATE, reqObj);

    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      toast.error(response);
      return [];
    }
  } catch (error) {
    toast.error(error.response.data);
    return [];
  }
};

export const updateTemplate = async (id, reqObj) => {
  try {
    const URL = APIPaths.UPDATE_TEMPLATE + id;
    const response = await axiosInstance.put(URL, reqObj);
    if (response.status === 200) {
      return response;
    } else {
      toast.error(response);
      return [];
    }
  } catch (error) {
    toast.error(error.response.data);
    return [];
  }
};

export const getTemplateById = async (id) => {
  try {
    const URL = APIPaths.GET_TEMPLATE_BY_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const getTemplateByTemplateName = async (templateName) => {
  try {
    const URL = APIPaths.GET_TEMPLATE_EXERCISE_LIST_BY_NAME + templateName;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {
    toast.error("Something went wrong");
  }
};

/**
 * Method Delete template by templateId
 * @param {*} templateId
 * @returns
 */
export const deleteTemplate = async (templateId) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_TEMPLATE}/${templateId}`,
    );
    if (response.status === 200) {
      toast.success("Template deleted successfully");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

/**
 * adds feedback for particular consultant
 * @param {*} reqObj
 * @returns
 */
export const addConsultantFeedback = async (reqObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.ADD_CONSULTANT_FEEDBACK,
      reqObj,
    );
    if (response.status === 200) {
      return response;
    } else {
      toast.error(response);
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

/**
 * returns feedbacks of particular consultant
 * @param {*} consultantId
 * @returns
 */
export const getFeedbackListByConsultantId = async (consultantId) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_CONSULTANT_FEEDBACK_BY_CONSULTANT_ID}/${consultantId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      toast.error("Failed to fetch feedback list.");
      console.error("Error fetching feedback list:", error);
      return [];
    });
  return response;
};

/**
 * returns list of diagnosis suggestions
 * @returns
 */
export const getDiagnosisSuggestionList = async () => {
  const response = await axiosInstance
    .get(APIPaths.GET_DIAGNOSIS_SUGGESTION_LIST)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      toast.error("Failed to fetch diagnosis suggestion list.");
      console.error("Error fetching diagnosis suggestion list:", error);
      return [];
    });
  return response;
};

export const addDiagnosisSuggestion = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.DIAGNOSIS_ADD, reqObj);
    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const addReferrer = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_REFERRER, reqObj);
    if (response.status === 201) {
      toast.success("Successfully added referrer");
      return response;
    } else {
      toast.error(response);
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getReferrersList = async (page, rowsPerPage, searchData) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_REFERRER}/${page}/${rowsPerPage}`, {
      params: {
        text: searchData,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching referrer list:", error);
      return [];
    });
  return response;
};

export const updateReferrer = async (bodyObj, referrerId) => {
  try {
    const response = await axiosInstance.post(
      `${APIPaths.UPDATE_REFERRER}/${referrerId}`,
      bodyObj,
    );
    if (response.status === 200) {
      toast.success("Referrer updated successfully.");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const deleteReferrer = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_REFERRER}/${id}`,
    );
    if (response.status === 200) {
      toast.success("Referrer deleted successfully.");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

/**
 * returns details of particular referrer by referrerId
 * @param {*} id
 * @returns
 */
export const getReferrerById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_REFERRER_BY_ID}/${id}`,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getReferrerFeesById = async (FromDate, toDate, id) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_REFERRER_FEES_BY_ID}/${FromDate}/${toDate}/${id}`,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

/**
 * Generate multiple appointment dates
 * @param {*} bodyObj
 * @returns
 */
export const getGeneratedAppointmentDates = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.GENERATE_APPOINTMENT_DATES,
      bodyObj,
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data);
    }

    return null;
  }
};

export const getClientImageDocumentsByAppointmentIdAndDocumentCategory = async (
  id,
  documentCategory,
) => {
  try {
    const URL = `${APIPaths.GET_CLIENT_IMAGE_DOCUMENT_BY_APPOINTMENT_ID}/${id}/${documentCategory}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    toast.error("Error while getting document");
  }
};

/**
 *
 * @returns list of treatment
 */
export const getAllTreatment = async () => {
  try {
    const response = await axiosInstance.get(APIPaths.GET_TREATMENT_LIST);
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

/**
 *
 * @param {*} treatmentName treatment plan
 * @param {*} treatmentTag treatment type
 * @returns list of medical procedure items based selected treatment and treatment type
 */
export const getAllMedicalProcedureItemsList = async (
  treatmentName,
  treatmentTag,
) => {
  try {
    const response = await axiosInstance.get(
      APIPaths.GET_MEDICAL_PROCEDURE_ITEMS_LIST,
      {
        params: {
          medicalProcedureName: treatmentName,
          medicalProcedureTag: treatmentTag,
        },
      },
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getConsultantListByAddressId = async (addressId) => {
  try {
    const URL = APIPaths.GET_CONSULTANT_LIST_BY_ADDRESS_ID + addressId;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

/**
 * adds dosage to organization
 * @param {*} reqObj
 * @returns
 */
export const addDosage = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.DOSAGE_ADD, reqObj);
    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

/**
 * adds instruction to organization
 * @param {*} reqObj
 * @returns
 */
export const addInstruction = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.INSTRUCTION_ADD, reqObj);
    if (response.status === 201) {
      return response;
    } else {
      toast.error(response);
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

/**
 *
 * @param {*} clientId
 * @param {*} consultantId
 * @returns list of medical procedure items based selected clientId and consultantId
 */
export const getAllMedicalProcedureByClientIdConsultantIdList = async (
  clientId,
  consultantId,
) => {
  try {
    const URL = `${APIPaths.GET_TREATMENT_PLAN_BY_CLIENT_ID_CONSULTANT_ID}${clientId}/${consultantId}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

/**
 *
 * @param {*} prescribedMedicalProcedureId
 * @param {*} prescribedMedicalProcedure
 * @returns list of medical procedure items based selected clientId and consultantId
 */
export const updatePendingMedicalProcedure = async (appointmentId, reqObj) => {
  try {
    const URL = `${APIPaths.UPDATE_PRESCRIBED_MEDICAL_PROCEDURE}${appointmentId}`;
    const response = await axiosInstance.post(URL, reqObj);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const deleteAppointmentById = async (appointmentId) => {
  try {
    const URL = `${APIPaths.DELETE_APPOINTMENT}${appointmentId}`;
    const response = await axiosInstance.delete(URL);
    if (response.status === 200) {
      toast.success(response.data.message);
      return response;
    }
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(error.response.data.message);
      return;
    }
  }
};

/**
 *
 * @param {*} clientId
 * @param {*} orgId
 * @param {*} visitDate
 * @param {*} consultantId
 * @returns The count of appointments for the given clientId and orgId, where the appointment visit dates are earlier than the provided visitDate.
 */
export const getAppointmentCountByClientId = async (
  clientId,
  orgId,
  visitDate,
  consultantId,
) => {
  try {
    const URL = `${APIPaths.GET_APPOINTMENT_COUNT_BY_CLIENT_ID}${clientId}/${orgId}/${visitDate}/${consultantId}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error("Error while getting appointment count");
  }
};

export const getTotalAppointmets = async (data) => {
  try {
    const URL = `${APIPaths.GET_TOTAL_APPOINTMENTS}`;
    const response = await axiosInstance.get(URL, {
      params: {
        from: data.from,
        to: data.to,
        interval: data.interval,
        visitType: data.visitType,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error(
      "An error occurred while fetching total appointments. Please try again.",
    );
  }
};

/**
 *
 * @param {*} clientId
 * @param {*} consultantId
 * @returns list of medicines to be paid by clientId and consultantId
 */
export const getMedicinesToBePaidByClientIdAndConsultantIdList = async (
  clientId,
  consultantId,
) => {
  try {
    const URL = `${APIPaths.GET_MEDICINES_TO_BE_PAID_BY_CLIENT_ID_CONSULTANT_ID}${clientId}/${consultantId}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong");
    }
  }
};

export const copyMedicinesFromPreviousPrescription = async (appointmentId) => {
  try {
    const URL = `${APIPaths.COPY_FROM_PREVIOUS_PRESCRIPTION}${appointmentId}`;
    const response = await axiosInstance.post(URL);
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong");
    }
  }
};

export const getAllVitalInfos = async () => {
  try {
    const URL = APIPaths.GET_ALL_VITAL_INFOS;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 204) {
      return [];
    }
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong");
    }
  }
};

export const addNewVital = async (reqObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_VITAL_INFO, reqObj);
    if (response.status === 201) {
      return response.data;
    } else {
      toast.error(response);
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
        return;
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const updateVitalInfo = async (reqObj, id) => {
  try {
    const url = `${APIPaths.UPDATE_VITAL_INFO}/${id}`;
    const response = await axiosInstance.post(url, reqObj);

    if (response.status === 201) {
      return response?.data;
    } else {
      toast.error(response);
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
        return;
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const deleteVitalInfoById = async (vitalInfoId) => {
  try {
    const URL = `${APIPaths.DELETE_VITAL_INFO_BY_ID}${vitalInfoId}`;
    const response = await axiosInstance.delete(URL);

    if (response.status === 200) {
      toast.success(response.data.message);
      return response;
    }
  } catch (error) {
    if (error?.response?.data) {
      toast.error(error.response.data);
      return;
    }

    toast.error(
      "An error occurred while deleting the vital information. Please try again.",
    );
  }
};

export const updatePatientRecords = async (appointmentId, bodyObj) => {
  try {
    const URL = APIPaths.UPDATE_PATIENT_RECORDS + appointmentId;
    const response = await axiosInstance.put(URL, bodyObj);
    if (response && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data);
    return error.response.data;
  }
};

export const changeConsultantFromAppointment = async (
  appointmentId,
  consultantId,
) => {
  try {
    const URL = `${APIPaths.CHANGE_APPOINTMENT_CONSULTANT}/${appointmentId}/${consultantId}`;
    const response = await axiosInstance.put(URL);
    if (response && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data);
    return error.response.data;
  }
};
export const getVitalInfoByClientId = async (clientId) => {
  try {
    const URL = `${APIPaths.GET_ALL_VITAL_INFO_BY_CLIENT_ID}${clientId}`;
    const response = await axiosInstance.get(URL);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response) {
      toast.error(error.response.data || "Something went wrong");
    } else if (error.request) {
      toast.error("No response received from the server");
    } else {
      toast.error("Something went wrong, please try again later");
    }
  }
};

export const getLastAppointmentReferrer = async (clientId) => {
  const URL = APIPaths.GET_LAST_APPOINTMENT_REFERRER + clientId;

  const response = await axiosInstance
    .get(URL)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return {};
    });

  return response.data;
};
